export default class CryptoService {
  constructor() {
    this.encoder = new TextEncoder()
    this.decoder = new TextDecoder()
  }

  // ========= Base64 工具 =========
  bufToBase64(buf) {
    return btoa(String.fromCharCode(...new Uint8Array(buf)))
  }

  base64ToBuf(b64) {
    return Uint8Array.from(atob(b64), c => c.charCodeAt(0))
  }

  // ========= 派生密钥（PBKDF2） =========
  async deriveKey(password, salt) {
    const keyMaterial = await crypto.subtle.importKey(
      "raw",
      this.encoder.encode(password),
      { name: "PBKDF2" },
      false,
      ["deriveKey"]
    )

    return crypto.subtle.deriveKey(
      {
        name: "PBKDF2",
        salt,
        iterations: 100000, // 可调高
        hash: "SHA-256"
      },
      keyMaterial,
      {
        name: "AES-GCM",
        length: 256
      },
      false,
      ["encrypt", "decrypt"]
    )
  }

  // ========= 加密 =========
  async encrypt(text, password) {
    try {
      const salt = crypto.getRandomValues(new Uint8Array(16))
      const iv = crypto.getRandomValues(new Uint8Array(12))

      const key = await this.deriveKey(password, salt)

      const ciphertext = await crypto.subtle.encrypt(
        {
          name: "AES-GCM",
          iv
        },
        key,
        this.encoder.encode(text)
      )

      return {
        ciphertext: this.bufToBase64(ciphertext),
        iv: this.bufToBase64(iv),
        salt: this.bufToBase64(salt)
      }
    } catch (err) {
      throw new Error("加密失败: " + err.message)
    }
  }

  // ========= 解密 =========
  async decrypt(encryptedData, password) {
    try {
      const salt = this.base64ToBuf(encryptedData.salt)
      const iv = this.base64ToBuf(encryptedData.iv)
      const ciphertext = this.base64ToBuf(encryptedData.ciphertext)

      const key = await this.deriveKey(password, salt)

      const plainBuffer = await crypto.subtle.decrypt(
        {
          name: "AES-GCM",
          iv
        },
        key,
        ciphertext
      )

      return this.decoder.decode(plainBuffer)
    } catch (err) {
      throw new Error("解密失败（密码错误或数据损坏）")
    }
  }
}